import api from "../index";

// Get achievements for the current user
export const getUserAchievements = async () => {
  return await api.get("/achievements");
};

// Mark tutorial as completed
export const completeTutorial = async (data: { tutorialId: string }) => {
  return await api.post("/achievements/tutorial", data);
};

// Get daily rewards status
export const getDailyRewardsStatus = async () => {
  return await api.get("/achievements/daily-status");
};

// Claim daily login reward
export const claimDailyLogin = async () => {
  return await api.post("/achievements/daily-login");
};

// Claim daily usage reward
export const claimDailyUsage = async () => {
  return await api.post("/achievements/daily-usage");
};

// Trigger usage check
export const checkUsageActivity = async () => {
  return await api.post("/achievements/check-usage");
};